import React, { lazy, Suspense } from 'react';

const CustomerPhone = lazy(() => {
  switch (process.env.REACT_APP_CUSTOMER) {
    case 'frs':
      return import('owl/customers/frs/Name');
    case 'trindco':
      return import('owl/customers/trindco/Name');
    case 'tcf':
      return import('owl/customers/tcf/Name');
    case 'simple':
      return import('owl/customers/simple/Name');
    case 'dev':
      return import('owl/customers/dev/Name');
    default:
      console.log('REACT_APP_CUSTOMER', process.env.REACT_APP_CUSTOMER);
      throw new Error('REACT_APP_CUSTOMER not set');
  }
});

export const Name = () => {
  return (
    <>
      <Suspense>
        <CustomerPhone />
      </Suspense>
    </>
  );
};

export default Name;
